import { createFileRoute } from '@tanstack/react-router'

/** Route definition for the agency approval-pending waiting screen. */
export const Route = createFileRoute('/agency/pending')({})
